import React from "react";
import "./Auth.css";
import { initGoogleAuth } from "../../firebaseModules/auth/auth";
import { getApiCallable, showNotif } from "../../firebaseModules/apiclient";
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { googleLoginSuccess, googleLoginFail } from '../../reduxModules/authReducer/authActions';
import { Redirect } from "react-router-dom";
import * as firebase from "firebase/app";
import { Spin } from 'antd';
import "firebase/auth";
import "firebase/firestore";
import { validateUser } from '../../utils/utils';
class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boolLoading: false
    }
  }
  componentWillMount() {
    this.initGoogleAuth();
  }
  componentWillReceiveProps(nextProps) {
    this.authListener();
  }
  initGoogleAuth = async () => {
    try {
      this.setLoading(true);
      const authResult = await firebase.auth().getRedirectResult();
      const idToken = authResult.credential.idToken;
      const googleLoginCallable = getApiCallable("googleLogin");
      const authRes = await googleLoginCallable({ token: idToken });
      this.setLoading(false);
      this.props.googleLoginSuccess(authRes);
    } catch (error) {
      showNotif(error);
      this.setLoading(false);
      this.props.googleLoginFail();
    }
  }
  setLoading = (bool) => {
    this.setState({ boolLoading: bool });
  }
  handleGoogleAuth = async () => {
    try {
      this.setLoading(true);
      const { idToken } = await initGoogleAuth();
      const googleLoginCallable = getApiCallable("googleLogin");
      const authRes = await googleLoginCallable({ token: idToken });
      this.props.googleLoginSuccess(authRes);
      this.setLoading(false);
    } catch (error) {
      console.log(error);
      showNotif(error);
      this.setLoading(false);
      this.props.googleLoginFail();
    }
  }
  authListener = (props) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (
          this.props.authReducer &&
          !this.props.authReducer.user &&
          !this.state.loading &&
          validateUser({ email: user.email })
        ) {
          this.props.googleLoginSuccess({ data: { name: user.displayName, email: user.email }});
        }
      }
    });
  }
  render() {
    if (!!this.props.authReducer.user && !!this.props.authReducer.user.email) {
      return <Redirect to="/" />
    }

    // if (this.state.authReducer && !this.state.authReducer.user && !this.state.loading) {
    //   const currentUser = getCurrentUser();
    //   if (currentUser) {
    //     this.props.googleLoginSuccess({ data: { name: currentUser.displayName, email: currentUser.email } });
    //   }
    // }
    return (
      <div className="authWrapper">
        {
          this.state.boolLoading &&
          <div className="overlay">
            <Spin />
          </div>
        }
        <div className="button-container" onClick={this.handleGoogleAuth}>
          <img src={require('../../assets/images/complete_button.png')} className="image" alt=""/>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    authReducer: state.authReducer
  }),
  (dispatch) => bindActionCreators({ googleLoginSuccess, googleLoginFail }, dispatch)
)(Auth);
